export const checkNegative = value => {
  return value.toString().indexOf('-') > -1 && (!value || value !== '')
    ? 'negative'
    : ''
}
